// extracted by mini-css-extract-plugin
export var fadeIn = "_87-0";